
























































































































































































































































































import Vue from 'vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import moment from 'moment'
import { DatePeriodEnum, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { DatePeriod } from '@/model/DatePeriod'
import { hexToRgba } from '@/services/hex-to-rgba'
import DeleteDialog from '@/components/DeleteDialog.vue'
import AdditionalServicesFormDialog from '@/components/planning/AdditionalServicesFormDialog.vue'
import AdditionalServicesExpensesFormDialog from '@/components/planning/AdditionalServicesExpensesFormDialog.vue'
import {
  DELETE_ADDITIONAL_SERVICE, DELETE_ADDITIONAL_SERVICE_EXPENSES,
  FETCH_ADDITIONAL_SERVICES, FETCH_ADDITIONAL_SERVICES_CURRENCY_LIST,
  FETCH_ADDITIONAL_SERVICES_DISCOUNT,
  FETCH_ADDITIONAL_SERVICES_DISCOUNT_LIST,
  FETCH_ADDITIONAL_SERVICES_EXPENSES,
  FETCH_ADDITIONAL_SERVICES_PRODUCT_LIST,
  FETCH_ADDITIONAL_SERVICES_PROVISION,
  FETCH_ADDITIONAL_SERVICES_PROVISION_LIST
} from '@/store/action-types'
import { AdditionalServices } from '@/model/planning/AdditionalServices'
import { AdditionalServicePayload, AdditionalServicesPayload } from '@/types/payload'
import { AdditionalServicesProduct } from '@/model/planning/AdditionalServicesProduct'
import { TranslateResult } from 'vue-i18n'
import { Currency } from '@/model/planning/Currency'

interface ComponentData {
  positions: any
  loading: boolean
  saveInProgress: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  gridData: AdditionalServices[]
  gridData1: AdditionalServices[]
  gridData2: AdditionalServices[]
  gridData3: AdditionalServices[]
  gridData4: AdditionalServices[]
  headers1: any
  headers2: any
  headers5: any
  headers3: any
  headers4: any
  overlayNoRowsTemplate: string
  period: DatePeriod | undefined
  showSearchField: boolean
  showSearchField1: boolean
  showSearchField2: boolean
  showSearchField3: boolean
  showSearchField4: boolean
  search: string | null
  searchExpenses1: string | null
  searchExpenses2: string | null
  searchExpenses3: string | null
  searchExpenses4: string | null
  currentSelectedRowData: AdditionalServices | undefined
  currentSelectedRowData1: AdditionalServices | undefined
  currentSelectedRowData2: AdditionalServices | undefined
  currentSelectedRowData3: AdditionalServices | undefined
  currentSelectedRowData4: AdditionalServices | undefined
  showDialog: boolean
  showDeleteDialog: boolean
  dialogTitle: string
  showExpensesDialog: boolean
  currentSelectedExpensesRowData: AdditionalServices | undefined
  expensesAction: number | null
  isAdditionalServicesEdit: boolean
  isExpensesEdit: boolean
  activeTab: number
  productProvisionDiscountList: AdditionalServicesProduct[]
  currencyList: Currency[]
}

export default Vue.extend({
  name: 'AdditionalServicesDialog',

  components: {
    ProgressCircular,
    DeleteDialog,
    AdditionalServicesFormDialog,
    AdditionalServicesExpensesFormDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    currentPeriod: Object as () => DatePeriod,
    title: String,
    additionalServicesAction: Number,
    defaultCurrency: Number
  },

  data (): ComponentData {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      loading: false,
      saveInProgress: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      gridData: [],
      gridData1: [],
      gridData2: [],
      gridData3: [],
      gridData4: [],
      headers1: [
        { text: this.$t('planningPage.tableProduct').toString(), value: 'productName', align: 'start', groupable: false },
        { text: this.$t('planningPage.tableDescription').toString(), value: 'description', align: 'start', groupable: false, width: 250 },
        { text: this.$t('planningPage.tableAmount').toString(), value: 'quantity', align: 'right', groupable: false, width: 100 },
        { text: this.$t('planningPage.tablePrice').toString(), value: 'price', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableTotalAmountEx').toString(), value: 'total', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableCurrency').toString(), value: 'currency', align: 'center', groupable: false, width: 100 }
      ],
      headers2: [
        { text: this.$t('planningPage.tableDescription').toString(), value: 'description', align: 'start', groupable: false },
        { text: this.$t('planningPage.tableTotalAmountIn').toString(), value: 'price', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableCurrency').toString(), value: 'currency', align: 'center', groupable: false, width: 100 }
      ],
      headers5: [
        { text: this.$t('planningPage.tableDescription').toString(), value: 'description', align: 'start', groupable: false },
        { text: this.$t('planningPage.tableTotalAmountEx').toString(), value: 'price', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableCurrency').toString(), value: 'currency', align: 'center', groupable: false, width: 100 }
      ],
      headers3: [
        { text: this.$t('planningPage.tableProvision').toString(), value: 'productName', align: 'start', groupable: false },
        { text: this.$t('planningPage.tableDescription').toString(), value: 'description', align: 'start', groupable: false, width: 250  },
        { text: this.$t('planningPage.tableAmount').toString(), value: 'quantity', align: 'right', groupable: false, width: 100 },
        { text: this.$t('planningPage.tablePrice').toString(), value: 'price', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableTotalAmountEx').toString(), value: 'total', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableCurrency').toString(), value: 'currency', align: 'center', groupable: false, width: 100 }
      ],
      headers4: [
        { text: this.$t('planningPage.discount').toString(), value: 'productName', align: 'start', groupable: false },
        { text: this.$t('planningPage.tableDescription').toString(), value: 'description', align: 'start', groupable: false, width: 250  },
        { text: this.$t('planningPage.tableAmount').toString(), value: 'quantity', align: 'right', groupable: false, width: 100 },
        { text: this.$t('planningPage.tablePrice').toString(), value: 'price', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableTotalAmountEx').toString(), value: 'total', align: 'right', groupable: false, width: 160 },
        { text: this.$t('planningPage.tableCurrency').toString(), value: 'currency', align: 'center', groupable: false, width: 100 }
      ],
      overlayNoRowsTemplate: this.$t('errors.noRowsToShow').toString(),
      period: undefined,
      showSearchField: false,
      showSearchField1: false,
      showSearchField2: false,
      showSearchField3: false,
      showSearchField4: false,
      search: null,
      searchExpenses1: null,
      searchExpenses2: null,
      searchExpenses3: null,
      searchExpenses4: null,
      currentSelectedRowData: undefined,
      currentSelectedRowData1: undefined,
      currentSelectedRowData2: undefined,
      currentSelectedRowData3: undefined,
      currentSelectedRowData4: undefined,
      showDialog: false,
      showDeleteDialog: false,
      dialogTitle: '',
      showExpensesDialog: false,
      currentSelectedExpensesRowData: undefined,
      expensesAction: null,
      isAdditionalServicesEdit: false,
      isExpensesEdit: false,
      activeTab: 0,
      productProvisionDiscountList: [],
      currencyList: []
    }
  },

  watch: {
    currentPeriod (newVal: DatePeriod): void {
      if(newVal) {
        this.period = this.currentPeriod
        this.currentSelectedRowData = undefined
        this.fetchData()
      }
    },

    additionalServicesAction (newVal: number): void {
      if(newVal) {
        this.currentSelectedRowData = undefined
        this.fetchData()
      }
    }
  },

  computed: {
    getPosition (): Object {
      const top : number = (window.innerHeight - 100 - 400) / 2
      const left : number = (window.innerWidth - 1000) / 2
      return {top: `${top}px`, left: `${left}px`}
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getTitle (): string {
      let begin = moment(this.currentPeriod.startDate).startOf(DatePeriodEnum.Month)
      let end = moment(this.currentPeriod.endDate).endOf(DatePeriodEnum.Month)

      if(this.period) {
        begin = moment(this.period.startDate).startOf(DatePeriodEnum.Month)
        end = moment(this.period.endDate).endOf(DatePeriodEnum.Month)
      }

      let beginStr, endStr

      const beginMonth = begin.format('MMM')
      const endMonth = end.format('MMM')

      if (beginMonth === endMonth) {
        beginStr = begin.format('DD')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      } else {
        beginStr = begin.locale(this.selectedLocale).format('DD MMM')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      }
      const yearStr = end.format('YYYY')

      return `${beginStr} - ${endStr} ${yearStr}`
    },

    isEnableEditDeleteButton (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    isEnableEditDeleteButton1 (): boolean {
      return !!(this.currentSelectedRowData1 && this.currentSelectedRowData1.id)
    },

    isEnableEditDeleteButton2 (): boolean {
      return !!(this.currentSelectedRowData2 && this.currentSelectedRowData2.id)
    },

    isEnableEditDeleteButton3 (): boolean {
      return !!(this.currentSelectedRowData3 && this.currentSelectedRowData3.id)
    },

    isEnableEditDeleteButton4 (): boolean {
      return !!(this.currentSelectedRowData4 && this.currentSelectedRowData4.id)
    },


    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    isSearchEnabled1 (): boolean {
      return this.gridData1.length > 0
    },

    isSearchEnabled2 (): boolean {
      return this.gridData2.length > 0
    },

    isSearchEnabled3 (): boolean {
      return this.gridData3.length > 0
    },

    isSearchEnabled4 (): boolean {
      return this.gridData4.length > 0
    },

    filteredGridData (): AdditionalServices[] {
      if(this.search) {
        return this.gridData.filter((item: AdditionalServices) => {
          return item.addressLabel.toLowerCase().includes(this.search!.toLowerCase())
        })
      } else {
        return this.gridData
      }
    },

    filteredGridData1 (): any[] {
      if(this.searchExpenses1) {
        return this.gridData1.filter((item: AdditionalServices) => {
          return item.employeeLabel.toLowerCase().includes(this.searchExpenses1!.toLowerCase())
        })
      } else {
        return this.gridData1
      }
    },

    filteredGridData2 (): AdditionalServices[] {
      if(this.searchExpenses2) {
        return this.gridData2.filter((item: AdditionalServices) => {
          return item.addressLabel.toLowerCase().includes(this.searchExpenses2!.toLowerCase())
        })
      } else {
        return this.gridData2
      }
    },

    filteredGridData3 (): AdditionalServices[] {
      if(this.searchExpenses3) {
        return this.gridData3.filter((item: AdditionalServices) => {
          return item.employeeLabel.toLowerCase().includes(this.searchExpenses3!.toLowerCase())
        })
      } else {
        return this.gridData3
      }
    },

    filteredGridData4 (): AdditionalServices[] {
      if(this.searchExpenses4) {
        return this.gridData4.filter((item: AdditionalServices) => {
          return item.addressLabel.toLowerCase().includes(this.searchExpenses4!.toLowerCase())
        })
      } else {
        return this.gridData4
      }
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    rowClick (item: AdditionalServices, row: any): void {
      this.currentSelectedRowData = item
      row.select(true)
    },

    rowClick1 (item: AdditionalServices, row: any): void {
      this.currentSelectedRowData1 = item
      row.select(true)
    },

    rowClick2 (item: AdditionalServices, row: any): void {
      this.currentSelectedRowData2 = item
      row.select(true)
    },

    rowClick3 (item: AdditionalServices, row: any): void {
      this.currentSelectedRowData3 = item
      row.select(true)
    },

    rowClick4 (item: AdditionalServices, row: any): void {
      this.currentSelectedRowData4 = item
      row.select(true)
    },

    onAddAdditionalServiceClick (action: number, expenses?: number): void {
      this.isAdditionalServicesEdit = false
      this.currentSelectedRowData = undefined
      switch (action) {
        case 1:
          this.dialogTitle = this.$t('planningPage.addProductsServices').toString()
          break
        case 3:
          if(expenses && expenses === 3) {
            this.expensesAction = expenses
            this.dialogTitle = this.$t('planningPage.addEmployeeProvision').toString()
          } else if(expenses && expenses === 4) {
            this.expensesAction = expenses
            this.dialogTitle = this.$t('planningPage.addAddressProvision').toString()
          }
          break
        case 4:
          this.dialogTitle = this.$t('planningPage.addDiscounts').toString()
          break
      }
      this.showDialog = true
    },

    onEditAdditionalServiceClick (action: number, expenses?: number): void {
      switch (action) {
        case 1:
          this.dialogTitle = this.$t('planningPage.editProductsServices').toString()
          break
        case 3:
          if(expenses && expenses === 3) {
            this.expensesAction = expenses
            this.dialogTitle = this.$t('planningPage.editEmployeeProvision').toString()
            this.currentSelectedRowData =  this.currentSelectedRowData3
          } else if(expenses && expenses === 4){
            this.expensesAction = expenses
            this.currentSelectedRowData =  this.currentSelectedRowData4
            this.dialogTitle = this.$t('planningPage.editAddressProvision').toString()
          }
          break
        case 4:
          this.dialogTitle = this.$t('planningPage.editDiscounts').toString()
          break
      }
      this.isAdditionalServicesEdit = true
      this.showDialog = true
    },

    onAddExpensesClick (action: number): void {
      this.isExpensesEdit = false
      this.expensesAction = action
      this.currentSelectedExpensesRowData = undefined
      switch (action) {
        case 1:
          this.dialogTitle = this.$t('planningPage.addEmployeeExpenses').toString()
          break
        case 2:
          this.dialogTitle = this.$t('planningPage.addAddressExpenses').toString()
          break
      }
      this.showExpensesDialog = true
    },

    onEditExpensesClick (action: number): void {
      switch (action) {
        case 1:
          this.expensesAction = action
          this.currentSelectedExpensesRowData = this.currentSelectedRowData1
          this.dialogTitle = this.$t('planningPage.editEmployeeExpenses').toString()
          break
        case 2:
          this.expensesAction = action
          this.currentSelectedExpensesRowData = this.currentSelectedRowData2
          this.dialogTitle = this.$t('planningPage.editAddressExpenses').toString()
          break
      }

      this.isExpensesEdit = true
      this.expensesAction = action
      this.showExpensesDialog = true
    },

    onDialogSaved (): void {
      this.onDialogClose()
      this.fetchData()
    },

    onDialogClose (): void {
      this.showDialog = false
    },

    onExpensesDialogSave (): void {
      this.onExpensesDialogClose()
      this.fetchData()
    },

    onExpensesDialogClose  (): void {
      this.showExpensesDialog = false
    },

    onDeleteAdditionalServiceClick (): void {
      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      if(this.currentSelectedRowData) {
        this.deleteAdditionalService()
      } else if(this.additionalServicesAction === 3 && (this.expensesAction === 1 || 2) && this.currentSelectedExpensesRowData) {
        this.deleteExpenses()
      }
    },

    onDeleteExpensesClick (action: number): void {

      switch (action) {
        case 1:
          this.currentSelectedExpensesRowData = this.currentSelectedRowData1
          break
        case 2:
          this.currentSelectedExpensesRowData = this.currentSelectedRowData2
          break
        case 3:
          this.currentSelectedRowData = this.currentSelectedRowData3
          break
        case 4:
          this.currentSelectedRowData = this.currentSelectedRowData4
          break
      }

      this.expensesAction = action
      this.showDeleteDialog = true
    },

    async deleteAdditionalService (): Promise<void> {
      const payload: AdditionalServicePayload = {
        id: this.currentSelectedRowData!.id,
        LGID: 0,
        addressId: this.currentSelectedRowData!.addressId,
        year: parseInt(moment(this.period!.startDate).format('YYYY')),
        month: this.period!.number,
        employeeId: 0,
        productId: this.currentSelectedRowData!.productId,
        amount: parseFloat(this.currentSelectedRowData!.quantity),
        price: parseFloat(this.currentSelectedRowData!.price),
        description: this.currentSelectedRowData!.description,
        currency: this.currentSelectedRowData!.currency,
        type: this.additionalServicesAction === 1 ? 'LEISTUNGEN' : ''
      }

      try {
        this.loading = true
        const response: boolean = await this.$store.dispatch(DELETE_ADDITIONAL_SERVICE, payload)
        if(response) {
          this.currentSelectedRowData = undefined
          if(this.expensesAction === 3) {
            this.currentSelectedRowData3 = undefined
          } else if(this.expensesAction === 4) {
            this.currentSelectedRowData4 = undefined
          }
          this.onDeleteDialogClose()
          this.fetchData()
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    async deleteExpenses (): Promise<void> {
      const payload: AdditionalServicePayload = {
        id: this.currentSelectedExpensesRowData!.id,
        LGID: 0,
        addressId: this.currentSelectedExpensesRowData!.addressId,
        year: parseInt(moment(this.period!.startDate).format('YYYY')),
        month: this.period!.number,
        employeeId: this.currentSelectedExpensesRowData!.employeeId,
        productId: this.currentSelectedExpensesRowData!.productId,
        amount: parseFloat(this.currentSelectedExpensesRowData!.quantity),
        price: parseFloat(this.currentSelectedExpensesRowData!.price),
        description: this.currentSelectedExpensesRowData!.description,
        currency: this.currentSelectedExpensesRowData!.currency,
        type: ''
      }

      try {
        this.loading = true
        const response: boolean = await this.$store.dispatch(DELETE_ADDITIONAL_SERVICE_EXPENSES, payload)
        if(response) {
          if(this.expensesAction === 1) {
            this.currentSelectedRowData1 = undefined
          } else if(this.expensesAction === 2) {
            this.currentSelectedRowData2 = undefined
          }
          this.currentSelectedExpensesRowData = undefined
          this.onDeleteDialogClose()
          this.fetchData()
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    },

    onSearchButton1Click (): void {
      this.showSearchField1 = !this.showSearchField1
      if(!this.showSearchField1) {
        this.searchExpenses1 = null
      }
    },

    onSearchButton2Click (): void {
      this.showSearchField2 = !this.showSearchField2
      if(!this.showSearchField2) {
        this.searchExpenses2 = null
      }
    },

    onSearchButton3Click (): void {
      this.showSearchField3 = !this.showSearchField3
      if(!this.showSearchField3) {
        this.searchExpenses3 = null
      }
    },

    onSearchButton4Click (): void {
      this.showSearchField4 = !this.showSearchField4
      if(!this.showSearchField4) {
        this.searchExpenses4 = null
      }
    },

    async fetchData (): Promise<void> {
      const month: number = parseInt(moment(this.period!.startDate).format('M'))
      let secondMonth: number | string = ''
      let secondYear: number | string = ''

      if (moment(this.period!.startDate).format('M') !== moment(this.period!.endDate).format('M')) {
        secondMonth = moment(this.period!.endDate).format('M')
        secondYear = moment(this.period!.endDate).format('YYYY')
      }

      this.loading = true

      let payload : AdditionalServicesPayload | undefined = undefined

      switch (this.additionalServicesAction) {
        case 1:
          payload = {
            year: moment(this.period!.startDate).format('YYYY'),
            secondYear: secondYear,
            month: month,
            secondMonth: secondMonth,
            type: 'LEISTUNGEN'
          }

          this.fetchAdditionalServicesData(payload)
          break
        case 2:

          break
        case 3:
          payload = {
            year: moment(this.period!.startDate).format('YYYY'),
            secondYear: secondYear,
            month: month,
            secondMonth: secondMonth,
            type: ''
          }

          this.fetchAdditionalServicesData(payload)
          break
        case 4:
          payload = {
            year: moment(this.period!.startDate).format('YYYY'),
            secondYear: secondYear,
            month: month,
            secondMonth: secondMonth,
            type: ''
          }

          this.fetchAdditionalServicesData(payload)
          break
      }
      this.fetchProductProvisionDiscountList()
      this.loading = false
    },

    async fetchAdditionalServicesData (payload: AdditionalServicesPayload): Promise<void> {
      if(this.additionalServicesAction === 1) {
        this.gridData = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES, payload)
      } else if(this.additionalServicesAction === 3) {
        const responseExpenses: AdditionalServices[] = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_EXPENSES, payload)
        this.gridData1 = responseExpenses.filter((item: AdditionalServices) => !item.addressId || item.addressId === 0)
        this.gridData2 = responseExpenses.filter((item: AdditionalServices) => item.addressId && item.addressId !== 0)
        const response: AdditionalServices[] = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_PROVISION, payload)
        this.gridData3 = response.filter((item: AdditionalServices) => !item.addressId || item.addressId === 0)
        this.gridData4 = response.filter((item: AdditionalServices) => item.addressId && item.addressId !== 0)
      } else if(this.additionalServicesAction === 4) {
        this.gridData = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_DISCOUNT, payload)
      }
    },

    async fetchProductProvisionDiscountList (): Promise<void> {
      if(this.additionalServicesAction === 1) {
        this.productProvisionDiscountList = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_PRODUCT_LIST)
      } else if(this.additionalServicesAction === 3) {
        this.currencyList = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_CURRENCY_LIST)
        this.productProvisionDiscountList = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_PROVISION_LIST)
      } else if(this.additionalServicesAction === 4) {
        this.productProvisionDiscountList = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_DISCOUNT_LIST)
      }
    },

    dragMouseDown: function (event: any) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event: any) {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      event.preventDefault()

      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      if((container.offsetTop - this.positions.movementY) > -64 && (container.offsetTop - this.positions.movementY + container.clientHeight + 64) < event.view.innerHeight) {
        container.style.top = (container.offsetTop - this.positions.movementY) + 'px'
      } else if ((container.offsetTop - this.positions.movementY) < -64) {
        container.style.top = -64 + 'px'
      } else if ((container.offsetTop - this.positions.movementY) + container.clientHeight + 64 > event.view.innerHeight) {
        container.style.top = (event.view.innerHeight - (container.clientHeight + 64)) + 'px'
      }

      if((container.offsetLeft - this.positions.movementX) > 0 && (container.offsetLeft - this.positions.movementX + container.clientWidth + 18) < event.view.innerWidth) {
        container.style.left = (container.offsetLeft - this.positions.movementX) + 'px'
      } else if((container.offsetLeft - this.positions.movementX) < 0) {
        container.style.left = 0 + 'px'
      } else if((container.offsetLeft - this.positions.movementX + container.clientWidth + 18) > event.view.innerWidth) {
        container.style.left = (event.view.innerWidth - container.clientWidth - 18) + 'px'
      }
    },

    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    }
  },

  mounted (): void {
    this.period = this.currentPeriod
    this.fetchData()
  }
})
